import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPartnerMarketingHomeBlocks } from "app/reducers/partnerSelector";
import SmartDP from "app/pages/SmartDP/SmartDP";
import { getQuoteStatus } from "app/pages/Booking/Quotation/quotationSelectors";
import { fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import { fetchSDPAvailableDepartureDate } from "app/pages/SmartDP/smartDPActionCreators";
import { parse } from "qs";
import { getSdpRotationUri } from "./smartDPSelectors";
import withRouter from "app/utils/hocs/withRouter";

const mapStateToProps = (state, ownProps) => {
	const queryParams = parse(ownProps?.location?.search, { ignoreQueryPrefix: true });
	return {
		booking: state.booking,
		homeBlocks: getPartnerMarketingHomeBlocks(state),
		fetchSDPProductsStatus: state.smartDP.status,
		fetchSDPAvailabilitiesStatus: getQuoteStatus(state),
		hasSdpSpecialOffer: state.smartDP.specialOffer, // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.smartDP.specialOfferInfos,
		sdpRotationUri: getSdpRotationUri(queryParams)(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPFilters,
			fetchSDPAvailableDepartureDate,
		},
		dispatch
	);
};
export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(SmartDP)
);
